import { Generators } from '@adaptiva/core/common';
import { MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { IAuthoringRuleNode } from '../interfaces';
import { AuthoringRuleUserInput } from '../types';
import { AndMetadataAuthoringRule } from './and-metadata-authoring-rule';
import { ExpressionMetadataAuthoringRule } from './expression-metadata-authoring-rule';
import { NotMetadataAuthoringRule } from './not-metadata-authoring-rule';
import { OrMetadataAuthoringRule } from './or-metadata-authoring-rule';
import { ReferenceMetadataAuthoringRule } from './reference-metadata-authoring-rule';

export class AuthoringRuleNode implements IAuthoringRuleNode {

	public id: long;

	public type: int;

	public display: string;

	public isExpanded: boolean = false;

	public children?: IAuthoringRuleNode[];

	public parentNode?: IAuthoringRuleNode;

	public userInput?: AuthoringRuleUserInput;

	constructor(_type: int, _parentNode?: IAuthoringRuleNode, _input?: AuthoringRuleUserInput, _display?: string) {
		this.type = _type;
		this.id = Generators.getIntId();

		if (_parentNode)
			this.parentNode = _parentNode;

		if (_input)
			this.setUserInput(_input, _display);
		else
			this._setDisplay(_type, _display);
	}

	public addChild(_type: number, _input?: AuthoringRuleUserInput, _display?: string): void {
		const _child: IAuthoringRuleNode = new AuthoringRuleNode(_type, this, _input, _display);

		if (this.children?.length)
			this.children.push(_child);
		else
			this.children = [_child];

		this.isExpanded = true;
	}

	public removeChild(_id: number): void {
		const _childIndex: number = this.children.findIndex(_n => _n.id === _id);

		if (_childIndex > -1) {
			this.children.splice(_childIndex, 1);
			if (!this.children.length)
				delete this.children;
		}
	}

	public toggle(): void {
		this.isExpanded = !this.isExpanded;
	}

	public setUserInput(_input: AuthoringRuleUserInput, _display?: string): void {
		this.userInput = _input;
		this._setDisplay(this.type, _display);
	}

	public createClass(): MetadataAuthoringRule {
		let _value: any;

		if (this.children?.length) {
			if (this.type !== MetadataAuthoringRule.NOT)
				_value = this.children.map(_child => _child.createClass());
			else
				_value = this.children.map(_child => _child.createClass())[0];
		} else
			_value = this.userInput;
		const _class: MetadataAuthoringRule = AuthoringRuleNode.createClassFromRuleType(
			this.type,
			_value
		);
		return _class || null;
	}

	private _setDisplay(_type: int, _display?: string): void {
		switch (_type) {
			case (MetadataAuthoringRule.AND): this.display = 'AND'; break;
			case (MetadataAuthoringRule.NOT): this.display = 'NOT'; break;
			case (MetadataAuthoringRule.OR): this.display = 'OR'; break;
			case (MetadataAuthoringRule.EXPRESSION): this.display = `${this.userInput}`; break;
			case (MetadataAuthoringRule.REFERENCE): this.display = _display ? _display : `Rule ${this.userInput}`; break;
			default: this.display = ''; break;
		}
	}

}

export namespace AuthoringRuleNode {
	export const createClassFromRuleType = (_ruleType: int, _value?: any): MetadataAuthoringRule => {
		switch (_ruleType) {
			case (MetadataAuthoringRule.AND):
				return new AndMetadataAuthoringRule(_value);
			case (MetadataAuthoringRule.NOT):
				return new NotMetadataAuthoringRule(_value);
			case (MetadataAuthoringRule.OR):
				return new OrMetadataAuthoringRule(_value);
			case (MetadataAuthoringRule.EXPRESSION):
				return new ExpressionMetadataAuthoringRule(_value);
			case (MetadataAuthoringRule.REFERENCE):
				return new ReferenceMetadataAuthoringRule(_value);
			default: return null;
		}
	};
}
